"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Handles string utilities.
 */
var StringUtility = /*#__PURE__*/function () {
  function StringUtility() {
    _classCallCheck(this, StringUtility);
  }

  _createClass(StringUtility, null, [{
    key: "capitalizeFirstLetter",

    /**
     * Capitalizes first letter.
     *
     * @param {string} string String to use.
     * @returns {string} String with first letter capitalized.
     */
    value: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    /**
     * Converts a camel case string to separate words with space inbetween.
     *
     * @param {string} string String to use.
     * @returns {string} Converted string.
     */

  }, {
    key: "camelCaseToWords",
    value: function camelCaseToWords(string) {
      return this.capitalizeFirstLetter(string.replace(/([A-Z0-9])/g, ' $1'));
    }
    /**
     * Converts a camel case string to kebab case.
     *
     * @example "buttonEnabled" will be converted to "button-enabled".
     * @param {string} string String to use.
     * @returns {string} Converted string.
     */

  }, {
    key: "camelToKebabCase",
    value: function camelToKebabCase(string) {
      return string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
    }
    /**
     * Converts a kebab case string to words.
     *
     * @example "button-enabled" will be converted to "Button Enabled".
     * @param {string} string String to use.
     * @returns {string} Converted string.
     */

  }, {
    key: "kebabCaseToWords",
    value: function kebabCaseToWords(string) {
      string = string.split('-');

      for (var i = 0, max = string.length; i < max; i++) {
        string[i] = this.capitalizeFirstLetter(string[i]);
      }

      return string.join(' ');
    }
  }]);

  return StringUtility;
}();

exports.default = StringUtility;